import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * SkipLinks - Keyboard navigation accessibility component
 * Allows users to skip to main content areas
 * WCAG 2.1 AA requirement for keyboard navigation
 */

const skipTargets = [
  { id: 'main-content', label: 'Skip to main content' },
  { id: 'navigation', label: 'Skip to navigation' },
  { id: 'search', label: 'Skip to search' },
];

const SkipLinks = () => {
  const handleSkip = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="sr-only focus-within:not-sr-only">
      <nav aria-label="Skip links" className="fixed top-0 left-0 z-[100] p-2">
        <ul className="flex gap-2">
          {skipTargets.map(({ id, label }) => (
            <li key={id}>
              <a
                href={`#${id}`}
                onClick={(e) => handleSkip(e, id)}
                className="skip-link bg-white dark:bg-gray-800 text-primary dark:text-blue-400 px-4 py-2 rounded-lg shadow-lg font-medium text-sm focus:outline-none focus:ring-2 focus:ring-primary"
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default SkipLinks;
